<template>
    <label v-if="label" class="inline-block custom-label" :for="name"
           :class="upperCase ? 'uppercase' : ''">
        {{ computedLabel }}:
    </label>
</template>

<script>
    export default {
        name: "CustomLabel",

        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            required: {
                type: Boolean,
                default: false,
            },
            upperCase: {
                type: Boolean,
                default: true,
            },
        },

        computed: {
            computedLabel() {
                if (this.label === undefined) return "";
                return (this.required ? "*" : "") + this.label;
            },
        },
    };

</script>

<style lang="scss">
    .field > label {
        margin: 0;
    }
</style>
